import { Outlet } from 'react-router';
import InactivityDialog from '../components/Auth/InactivityDialog';
import EulaDialog from '../components/Eula/EulaDialog';
import Navigation from '../components/Navigation/Navigation';
import useUserInactivity from '../hooks/useUserInactivity';

function MainLayout() {
  const { isDialogOpen, dialogCountdown, refreshUserSession, logoutUser } = useUserInactivity();
  return (
    <>
      <Navigation />
      <EulaDialog />
      <InactivityDialog
        open={isDialogOpen}
        dialogCountdown={dialogCountdown}
        handleStaySignedIn={refreshUserSession}
        handleUserLogout={logoutUser}
      />
      <Outlet />
    </>
  );
}

export default MainLayout;
